import { Button } from '@repo/ui/button'
import { Menu } from 'lucide-react'
import { type ReactNode, useState } from 'react'
import { useTranslation } from '@/lib/i18n'
import { BackofficeNavigation } from './backoffice-navigation'

export function BackofficeShell(props: {
	children: ReactNode
	contentClassName?: string
}) {
	const { t } = useTranslation()
	const [isNavigationOpen, setIsNavigationOpen] = useState(
		() =>
			typeof window === 'undefined' ||
			window.matchMedia('(min-width: 1024px)').matches
	)

	return (
		<div className='min-h-svh bg-background text-foreground'>
			<Button
				aria-expanded={isNavigationOpen}
				aria-label={t('common:open_navigation')}
				className='fixed top-4 left-4 z-30 shadow-sm lg:hidden'
				onClick={() => setIsNavigationOpen(true)}
				size='icon'
				variant='outline'
			>
				<Menu />
			</Button>
			<BackofficeNavigation
				isOpen={isNavigationOpen}
				onOpenChange={setIsNavigationOpen}
			/>
			<main
				className={`min-h-svh px-5 py-20 transition-[margin] duration-200 md:px-10 md:py-10 ${isNavigationOpen ? 'lg:ml-72' : 'lg:ml-20'}`}
			>
				<div
					className={`mx-auto w-full ${props.contentClassName ?? 'max-w-6xl'}`}
				>
					{props.children}
				</div>
			</main>
		</div>
	)
}
